export default __webpack_public_path__ + "static/media/iphone13-bg-dark.d01eca52.webp";